import './title.sass'

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

const titleStructure = [
  { label: 'recorderName', key: 'recorderName'},
  { label: 'vehicle', key: 'vehicle'},
  { label: 'name', key: 'name'},
  { label: 'startedAt', key: 'startedAtFormatted'},
  { label: 'origin', key: 'origin'},
  { label: 'destination', key: 'destination'}
];

export default class Title extends Component {
  buildMainTitle() {
    return titleStructure.map((item) => {
      return (
        <span key={ item.key }>
          <Translate value={ 'trackEvents.title.' + item.label} />
          &nbsp;-&nbsp;
          { this.props.track[item.key] },&nbsp;
        </span>
      );
    });
  }

  buildAditionalInfo() {
    let aditionalInfo = this.props.track.aditionalInfo || {};
    if (!Array.isArray(Object.keys(aditionalInfo))) {
      return '';
    }

    return Object.keys(aditionalInfo).map((key) => {
      return (
        <span key={ key }>
          <Translate value={ 'trackEvents.title.' + key} />
          &nbsp;-&nbsp;
          { aditionalInfo[key] },&nbsp;
        </span>
      );
    });
  }

  render() {
    return (
      <div className='track-events-title'>
        { this.buildMainTitle() }
        { this.buildAditionalInfo() }
      </div>
    );
  }
}

Title.propTypes = {
  track: PropTypes.shape({
    recorderName: PropTypes.string,
    vehicle: PropTypes.string,
    name: PropTypes.string,
    origin: PropTypes.string,
    destination: PropTypes.string,
    startedAtFormatted: PropTypes.string,
    recorderName: PropTypes.string,
    aditionalInfo: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array
    ])
  }).isRequired
};
